import { render, staticRenderFns } from "./sap-purchaseForecast-add-or-update.vue?vue&type=template&id=37a7d55d&scoped=true"
import script from "./sap-purchaseForecast-add-or-update.vue?vue&type=script&lang=js"
export * from "./sap-purchaseForecast-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./sap-purchaseForecast-add-or-update.vue?vue&type=style&index=0&id=37a7d55d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a7d55d",
  null
  
)

export default component.exports